import { z } from 'zod';
import { validateAssignmentV1, } from './assignment-v1.js';
/** Frozen canonical input. HTML and audio identities remain separate. */
export const AssignmentArtifactReferenceSchema = z.strictObject({
    format: z.literal('assignment_v1'),
    schemaVersion: z.literal(1),
    serializationVersion: z.literal(1),
    workingVersion: z.number().int().positive(),
    storageUri: z.string().min(1),
    contentHash: z.string().regex(/^[0-9a-f]{64}$/),
});
/** Version 1: sorted object keys, preserved array order and exact field strings. */
export function serializeAssignmentV1(assignment) {
    return JSON.stringify(assignment, (_key, value) => {
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            return Object.fromEntries(Object.entries(value).sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0)));
        }
        return value;
    });
}
export function parseAssignmentV1(text, context = {}) {
    let value;
    try {
        value = JSON.parse(text);
    }
    catch (error) {
        throw new Error(`Assignment JSON syntax error: ${error instanceof Error ? error.message : String(error)}`);
    }
    return validateAssignmentV1(value, context);
}
//# sourceMappingURL=assignment-artifact.js.map